module.exports = __webpack_public_path__ + "static/bitmap-federica-fragapane-750c6b6b802d9ee9a46b1a5f6191f523.png";